import { useAuth } from "../auth";
import { navigate } from "../router";

/** Fixed bottom banner shown while an admin is impersonating another account. */
export default function ImpersonationBanner() {
  const { user, impersonator, stopImpersonating } = useAuth();
  if (!impersonator || !user) return null;
  return (
    <div
      style={{
        position: "fixed",
        left: "50%",
        bottom: 18,
        transform: "translateX(-50%)",
        zIndex: 90,
        display: "flex",
        alignItems: "center",
        gap: 14,
        padding: "10px 14px 10px 18px",
        background: "#231A12",
        color: "#fff",
        borderRadius: 999,
        boxShadow: "0 14px 34px rgba(40,25,15,.25)",
        fontWeight: 600,
        fontSize: 13.5,
        maxWidth: "92vw",
      }}
    >
      <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        Viewing as{" "}
        <b style={{ fontFamily: '"Sprig", Georgia, serif', fontStyle: "italic", fontWeight: 600 }}>{user.displayName}</b>
      </span>
      <button
        style={{
          flex: "0 0 auto",
          border: "none",
          cursor: "pointer",
          background: "#AE8536",
          color: "#3a2a08",
          borderRadius: 999,
          padding: "7px 15px",
          fontFamily: "inherit",
          fontWeight: 700,
          fontSize: 12.5,
          whiteSpace: "nowrap",
        }}
        onClick={async () => {
          await stopImpersonating();
          navigate("/");
        }}
      >
        Return to {impersonator.displayName}
      </button>
    </div>
  );
}
